import { EndorsementsCtrl } from './endorsements.controller';

export const EndorsementsStepComponent = {
  controller: EndorsementsCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./endorsements.html'),
};
